import { createContext } from "react";

// null preserves the normal behavior outside employee-file tabs.
export default createContext(null);
